import React from 'react';
import AuthService from '../services/AuthService';
import {HeaderComponent} from './HeaderComponent';
import history from '../utils/customHistory';
import ReminderService from '../services/ReminderService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

let prevUrl = '';

class AuthComponent extends React.Component {
    constructor(props) {
        super(props);
        this.mainRef = React.createRef();
        this.authService = new AuthService();
        this.reminderService = new ReminderService();
        this.state = {
            reminders: undefined,
        };
    }
    componentDidMount() {
        const {roles, location} = this.props;
        if (this.authService.loggedOut()) {
            //history.replace('/login');
        } else {
            const userRoles = this.authService.getRoles();
            let authorized = false;
            if (roles !== undefined) {
                roles.forEach((role) => {
                    if (userRoles.includes(role)) {
                        authorized = true;
                    }
                });
            } else {
                authorized = true;
            }
            if (!authorized) {
                history.replace('/403');
            }
        }
    }

    getRemindersIfPossible() {
        if (window.location.href !== prevUrl && this.authService.loggedIn()) {
            prevUrl = window.location.href;
            console.log('fetching reminders');
            this.fetchReminders();
        }
    }
    fetchReminders() {
        this.reminderService.getList({}).then((res) => {
            this.setState({
                reminders: res,
            });
        }).catch(e =>{});
    }
    render() {
        this.getRemindersIfPossible();
        const {component, user} = this.props;
        return user ? (
            <React.Fragment>
                <HeaderComponent reminders={this.state.reminders} getReminders={() => this.fetchReminders()} />
                <div className='header-white-background large-width default-white-background '></div>
                <div ref={this.mainRef} className={`container-fluid large-width default-white-background `} style={{position: 'relative'}}>
                    {component}
                </div>
            </React.Fragment>
        ) : null;
    }
}
export default AuthComponent;
